import React, { useState } from "react";
import { NavLink } from "react-router-dom";

const CheckIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="#017737" style={{ display: "inline-block", verticalAlign: "middle" }}>
    <path d="M20.314 6.486a1 1 0 0 1 0 1.414L9.707 18.507a1 1 0 0 1-1.414 0l-3.985-3.985a1 1 0 1 1 1.414-1.414L9 16.386l9.9-9.9a1 1 0 0 1 1.414 0"></path>
  </svg>
);

const CrossIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="#d32f2f" style={{ display: "inline-block", verticalAlign: "middle" }}>
    <path d="M18.3 5.71a1 1 0 0 0-1.42 0L12 10.59 7.12 5.7a1 1 0 1 0-1.41 1.42l4.88 4.88-4.88 4.88a1 1 0 0 0 1.41 1.41L12 13.41l4.88 4.88a1 1 0 0 0 1.42-1.41l-4.89-4.88 4.89-4.88a1 1 0 0 0 0-1.42z"></path>
  </svg>
);

const SectionIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: "8px", verticalAlign: "middle" }}>
    <path d="M21.801 10A10 10 0 1 1 17 3.335"></path>
    <path d="m9 11 3 3L22 4"></path>
  </svg>
);

const Plans = () => {
  const [active, setActive] = useState("USD");
  const [currencySymbol, setCurrencySymbol] = useState("$");

  const changeCurrency = (curr) => {
    if (curr === "INR") {
      setActive("INR");
      setCurrencySymbol("₹");
    } else {
      setActive("USD");
      setCurrencySymbol("$");
    }
  };

  const styles = {

    highlightText: {
      fontWeight: "700",
      color: "#1d1e1f",
      fontSize: "18px",
      lineHeight: "32px",
    },

    container: {
      padding: "80px 20px",
      fontFamily: "'Roboto', sans-serif",
      maxWidth: "1200px",
      margin: "auto",
    },
    headingWrapper: {
      position: "relative",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      marginBottom: "40px",
      flexDirection: "column"
    },
    heading: {
      fontSize: "32px",
      fontWeight: "bold",
      textAlign: "center",
    },
    dropdownWrapper: {
      // position: "absolute",
      right: "0",
    },
    dropdown: {
      padding: "8px 12px",
      fontSize: "14px",
      borderRadius: "6px",
      border: "1px solid #ccc",
      backgroundColor: "#fff",
      appearance: "none",
      backgroundImage: 'url("data:image/svg+xml;utf8,<svg fill=\'%23333\' height=\'18\' viewBox=\'0 0 24 24\' width=\'18\' xmlns=\'http://www.w3.org/2000/svg\'><path d=\'M7 10l5 5 5-5z\'/></svg>")',
      backgroundRepeat: "no-repeat",
      backgroundPosition: "right 10px center",
      backgroundSize: "16px",
      paddingRight: "30px",
      cursor: "pointer",
      boxShadow: "0px 2px 8px rgba(0,0,0,0.1)",
      marginBottom: "0"
    },
    tableWrapper: {
      overflowX: "auto",
      borderRadius: "10px",
      boxShadow: "0px 8px 24px rgba(0,0,0,0.08)",
      backgroundColor: "#fff",
      border: "1px solid #e0e0e0",
    },
    table: {
      width: "100%",
      borderCollapse: "collapse",
      fontSize: "14px",
      minWidth: "800px",
    },
    th: {
      padding: "20px 12px",
      backgroundColor: "#ffffff",
      fontWeight: "bold",
      textAlign: "center",
      fontSize: "16px",
      verticalAlign: "middle",
    },
    td: {
      padding: "16px 10px",
      textAlign: "center",
      verticalAlign: "middle",
    },
    sectionHeaderStyle: {
      backgroundColor: "#f5faff",
      fontWeight: "600",
      padding: "16px 18px",
      textAlign: "left",
      fontSize: "15px",
      borderRadius: "12px",
      margin: "12px"
    },
    button: {
      padding: "10px 20px",
      backgroundColor: "#007bff",
      color: "#fff",
      border: "none",
      borderRadius: "6px",
      cursor: "pointer",
      fontSize: "14px",
      fontWeight: "bold",
    },
  };

  const renderCellContent = (value) => {
    if (value === true) return <CheckIcon />;
    if (value === false) return <CrossIcon />;
    return value;
  };

  const renderRow = (feature, starter, growth, pro, key) => (
    <tr key={key}>
      <td style={{ ...styles.td, textAlign: "left", fontWeight: "500", backgroundColor: "#fdfdfd", paddingLeft: "30px" }}>{feature}</td>
      <td style={styles.td}>{renderCellContent(starter)}</td>
      <td style={styles.td}>{renderCellContent(growth)}</td>
      <td style={styles.td}>{renderCellContent(pro)}</td>
    </tr>
  );

  const renderSection = (title, key) => (
    <tr key={key}>
      <td colSpan="4" style={styles.sectionHeaderStyle}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <SectionIcon />
          <span>{title}</span>
        </div>
      </td>
    </tr>
  );

  const renderPlanTitle = (name, price) => {
    const isGrowth = name === "Growth";

    return (
      <div>
        <div
          style={{
            ...styles.highlightText,
            // border: isGrowth ? "2px solid green" : styles.highlightText.border,
            // color: isGrowth ? "green" : styles.highlightText.color,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "6px",
            padding: "2px 12px",
          }}
        >
          <span>{name}</span>
          {isGrowth && (
            <span style={{
              fontWeight: 500, fontSize: "12px",
              // backgroundColor: "#b94b27",
              backgroundColor: "green",
              padding: "0px 6px",
              borderRadius: "32px",
              height: "18px",
              lineHeight: "18px",
              color: "#fff"
            }}>
              🔥Popular
            </span>
          )}
        </div>
        <div style={{ fontWeight: 'bold', color: "#4b5563", fontSize: "18px", marginTop: "4px" }}>
          {price}
        </div>
      </div>
    );
  };

  return (
    <div style={styles.container}>
      <div style={styles.headingWrapper}>
        <h1 className="heading39px roboto-bold mb10 text-color-131415">Choose the Best Plan for Your Hospitality Business</h1>
        <p className="heading18px roboto-regular mb20 text-color-131415">Scalable, transparent pricing — no hidden fees, cancel anytime.</p>
        <div style={styles.dropdownWrapper}>
          <div style={{ position: 'relative', display: 'inline-block' }}>
            <select
              id="currency"
              value={active}
              onChange={(e) => changeCurrency(e.target.value)}
              style={{
                padding: '10px 16px',
                fontSize: '15px',
                fontWeight: '500',
                borderRadius: '8px',
                border: '1px solid #d1d5db',
                backgroundColor: '#f9fafb',
                color: '#111827',
                appearance: 'none',
                backgroundImage: 'url("data:image/svg+xml;utf8,<svg fill=\'%23677\' height=\'20\' viewBox=\'0 0 24 24\' width=\'20\' xmlns=\'http://www.w3.org/2000/svg\'><path d=\'M7 10l5 5 5-5z\'/></svg>")',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'right 12px center',
                backgroundSize: '18px',
                paddingRight: '40px',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                boxShadow: '0px 4px 10px rgba(0,0,0,0.05)',
                marginBottom: '0'
              }}
              onMouseEnter={(e) => (e.target.style.backgroundColor = '#f3f4f6')}
              onMouseLeave={(e) => (e.target.style.backgroundColor = '#f9fafb')}
            >
              <option value="USD">USD ($)</option>
              <option value="INR">INR (₹)</option>
            </select>
          </div>
        </div>
      </div>

      <div style={styles.tableWrapper}>
        <table style={styles.table}>
          <thead>
            <tr>
              <th style={styles.th}>Feature / Plan</th>
              <th style={styles.th}>{renderPlanTitle("Starter", active === "USD" ? "$39/month" : "₹3,299/month")}</th>
              <th style={styles.th}>{renderPlanTitle("Growth", active === "USD" ? "$99/month" : "₹8,399/month")}</th>
              <th style={styles.th}>{renderPlanTitle("Pro", active === "USD" ? "$199/month" : "₹16,899/month")}</th>
            </tr>
          </thead>
          <tbody>
            {renderSection("Lead Generation & Capture", "lead")}
            {renderRow("Web-to-Lead Capture", true, true, true, "web-lead")}
            {renderRow("Custom Forms (Branded Forms)", true, true, true, "custom-forms")}
            {renderRow("Data-to-Lead Conversion", false, "Basic", "Full Access", "data-lead")}
            {renderRow("Integrated Data Sources", false, "Basic", "Full Access", "data-sources")}
            {renderRow("Kanban Pipeline View", false, "Basic Stages", "Customizable + Filters", "kanban")}

            {renderSection("Review & Reputation Management", "review")}
            {renderRow("Unified Review Management", false, "Google only", "Google + OTA platforms", "review-mgmt")}
            {renderRow("Review Response Templates", false, false, true, "response-templates")}
            {renderRow("Sentiment Insights (Upcoming)", false, false, true, "sentiment")}

            {renderSection("Engagement & Communication", "engagement")}
            {renderRow("Direct Email Integration", "1 inbox", "Up to 3 inboxes", "Multi-inbox + history", "direct-email")}
            {renderRow("Unified Lead Timeline", true, true, true, "lead-timeline")}
            {renderRow("WhatsApp Integration (Upcoming)", false, false, "Beta Access", "whatsapp")}
            {renderRow("Email Sequencing Engine (Upcoming)", false, "Lite", "Full Sequences + Triggers", "email-sequence")}

            {renderSection("Automation & Intelligence", "automation")}
            {renderRow("Gen AI Sales Widget (Upcoming)", false, "Suggestions Only", "Email Drafts + Reply Assist", "gen-ai")}
            {renderRow("Auto Lead Scoring & Tags", false, false, true, "lead-scoring")}
            {renderRow("Campaign Automation Rules", false, true, true, "campaign-rules")}

            {renderSection("Support & Add-ons", "support")}
            {renderRow("Email Support", true, true, true, "email-support")}
            {renderRow("Priority Support", false, false, true, "priority-support")}
            {renderRow("API / Webhook Access", false, false, true, "api-access")}
            {renderRow("Onboarding Support", "Basic", "Standard", "Dedicated", "onboarding")}

            <tr>
              <td style={{ ...styles.td, fontWeight: "bold", textAlign: "left", backgroundColor: "#fdfdfd" }}>&nbsp;</td>
              <td style={styles.td}>
                <NavLink to="/signup" className="common-btn-class main-btn-primary roboto-regular">
                  Get Started
                </NavLink>
              </td>
              <td style={styles.td}>
                <NavLink to="/signup" className="common-btn-class main-btn-primary roboto-regular">
                  Get Started
                </NavLink>
              </td>
              <td style={styles.td}>
                <NavLink to="/signup" className="common-btn-class main-btn-primary roboto-regular">
                  Get Started
                </NavLink>
              </td>
            </tr>
          </tbody>
        </table>

      </div>
    </div>
  );
};

export default Plans;